<template>
    <LoadingComponent :props="loading" />

    <section class="mb-18 mt-0 sm:mt-10 sm:mb-20">
        <div class="container">
            <CategoryBreadcrumbComponent :categories="ancestorsAndSelfCategories" rootRouteName="frontend.categories"
                rootLabelKey="label.categories" />

            <div class="flex items-center justify-between gap-4 mb-2 sm:mb-6 mt-4">
                <h2 class="text-2xl font-semibold capitalize">{{ selectedCategoryName }}</h2>
                <router-link :to="{ name: 'frontend.categories' }" class="text-sm font-medium text-primary hover:underline">
                    {{ $t('label.categories') }}
                </router-link>
            </div>

            <CategoryRecursiveGridComponent
                v-if="selectedChildren.length > 0"
                :nodes="selectedChildren"
                :title="''" />

            <div v-else class="border rounded-xl p-6">
                <p class="text-base text-text mb-4">{{ $t('message.no_item_found') }}</p>
                <router-link :to="{ name: 'frontend.product', query: { category: $route.params.slug } }"
                    class="text-sm font-medium text-primary hover:underline">
                    {{ $t('label.products') }}
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
import LoadingComponent from "../components/LoadingComponent";
import CategoryBreadcrumbComponent from "../components/CategoryBreadcrumbComponent.vue";
import CategoryRecursiveGridComponent from "../components/CategoryRecursiveGridComponent.vue";

export default {
    name: "CategoryChildrenGridComponent",
    components: {
        LoadingComponent,
        CategoryBreadcrumbComponent,
        CategoryRecursiveGridComponent
    },
    data() {
        return {
            loading: { isActive: false }
        }
    },
    computed: {
        ancestorsAndSelfCategories: function () {
            return this.$store.getters["frontendProductCategory/ancestorsAndSelf"];
        },
        categoryTrees: function () {
            return this.$store.getters["frontendProductCategory/trees"];
        },
        selectedNode: function () {
            return this.findNodeBySlug(this.categoryTrees, this.$route.params.slug);
        },
        selectedChildren: function () {
            return this.selectedNode && this.selectedNode.children ? this.selectedNode.children : [];
        },
        selectedCategoryName: function () {
            return this.selectedNode ? this.selectedNode.name : '';
        }
    },
    mounted() {
        this.bootstrap();
    },
    methods: {
        bootstrap() {
            this.loading.isActive = true;
            Promise.all([
                this.$store.dispatch("frontendProductCategory/trees"),
                this.$store.dispatch("frontendProductCategory/ancestorsAndSelf", this.$route.params.slug)
            ]).finally(() => {
                this.loading.isActive = false;
                this.redirectToProductsIfLeaf();
            });
        },
        redirectToProductsIfLeaf() {
            const hasNode = !!this.selectedNode;
            const hasChildren = Array.isArray(this.selectedChildren) && this.selectedChildren.length > 0;

            if (!hasNode || hasChildren) {
                return;
            }

            this.$router.replace({
                name: 'frontend.product',
                query: { category: this.$route.params.slug }
            }).catch(() => {
            });
        },
        findNodeBySlug(nodes, slug) {
            if (!Array.isArray(nodes)) {
                return null;
            }

            for (const node of nodes) {
                if (node.slug === slug) {
                    return node;
                }
                if (node.children && node.children.length) {
                    const found = this.findNodeBySlug(node.children, slug);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        }
    },
    watch: {
        $route() {
            this.bootstrap();
        }
    }
}
</script>
